// extracted by mini-css-extract-plugin
module.exports = {"popup-button":"PopupButton_popup-button__KXyo_","popup-button-label":"PopupButton_popup-button-label__xbQ2Z"};